import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createCaptureLicensing, getCaptureLicensing, updateCaptureLicensing } from "../../api/captures/licensing";
import { LicensingForm } from "../../types/forms/capture";

export const useCaptureLicensing = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const queryKey = ["capture", captureId, "licensing"];

  const result = useQuery({
    queryKey,
    queryFn: () => getCaptureLicensing(captureId),
    enabled: !!captureId,
  });

  const createMutation = useMutation({
    mutationFn: (values: LicensingForm) => createCaptureLicensing(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ licensingId, values }: { licensingId: number; values: LicensingForm }) => updateCaptureLicensing(captureId, licensingId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    licensingData: result.data ?? null,
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    createLicensing: createMutation.mutateAsync,
    updateLicensing: updateMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending,
  };
};
